export default (http, resource, apiVersion) => ({
    getLoggedInUser() {
        const method = 'get';
        const url = `${apiVersion}/${resource}`;
        const headers = {
            'Cache-Control': 'no-store'
        };
        return http({ method, url, headers });
    },
    updateProfile(data) {
        const method = 'put';
        const url = `${apiVersion}/${resource}`;
        return http({ method, url, data });
    }
});
